import { Button, Icon, IconButton, Text, HStack, Stack } from '@genial/components';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { PrivatePensionAssetController } from '../../../../../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PrivatePension';
import { PrivatePensionPortabilityInfo } from '../../../../../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PrivatePension/types';

export namespace PortabilityItemTypes {
  export interface Props {
    index: number;
    portability: PrivatePensionPortabilityInfo;
    onEdit: (index: number) => void;
    onRemove: (index: number) => void;
    offerController: PrivatePensionAssetController;
  }
}

export const PortabilityItem: React.FC<PortabilityItemTypes.Props> = ({
  index,
  portability,
  onEdit,
  onRemove,
  offerController,
}) => {
  const { insuranceOptions } = offerController;
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const insuranceCompanyName = insuranceOptions.find(
    (option) => Number(option.value) === portability.clientInsuranceCompany
  )?.label;

  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      width="full"
      space={{ base: 'stack.xxxs', sm: 'stack.nano' }}>
      <Stack direction={{ base: 'row', sm: 'column' }} flex={1} space="stack.quarck">
        <Text variant="semibold" flex={1}>
          Nome do plano
        </Text>
        <Text textAlign={{ base: 'right', sm: 'left' }} flex={1}>
          {portability.planName}
        </Text>
      </Stack>
      <Stack direction={{ base: 'row', sm: 'column' }} flex={1} space="stack.quarck">
        <Text variant="semibold" flex={1}>
          Seguradora cedente
        </Text>
        <Text textAlign={{ base: 'right', sm: 'left' }} flex={1}>
          {insuranceCompanyName}
        </Text>
      </Stack>
      <Stack direction={{ base: 'row', sm: 'column' }} flex={1} space="stack.quarck">
        <Text variant="semibold" flex={1}>
          SUSEP
        </Text>
        <Text textAlign={{ base: 'right', sm: 'left' }} flex={1}>
          {Utils.Mask.Susep(portability.susepNumber)}
        </Text>
      </Stack>
      <Stack direction={{ base: 'row', sm: 'column' }} flex={1} space="stack.quarck">
        <Text variant="semibold" flex={1}>
          Valor
        </Text>
        <Text textAlign={{ base: 'right', sm: 'left' }} flex={1}>
          {Utils.Mask.Money(portability.value)}
        </Text>
      </Stack>

      {isMobile ? (
        <Box flex={1} justifyContent="space-between" flexDirection="row">
          <Button
            variant="textLink"
            onPress={() => onEdit(index)}
            _text={{ color: 'brand.tertiary.principal' }}
            leftIcon={<Icon name="Edit" size="xs" color="brand.tertiary.principal" />}>
            EDITAR
          </Button>
          <Button
            variant="textLink"
            onPress={() => onRemove(index)}
            _text={{ color: 'feedback.error.default' }}
            leftIcon={<Icon name="Trash" size="xs" color="feedback.error.default" />}>
            REMOVER
          </Button>
        </Box>
      ) : (
        <HStack space="stack.nano">
          <IconButton
            testId="portability-item-edit-button"
            onPress={() => onEdit(index)}
            icon="Edit"
            iconSize="xs"
            iconColor="brand.tertiary.principal"
          />
          <IconButton
            testId="portability-item-remove-button"
            onPress={() => onRemove(index)}
            icon="Trash"
            iconSize="xs"
            iconColor="feedback.error.default"
          />
        </HStack>
      )}
    </Stack>
  );
};
